import { apiFetch } from "./apiClient";

export async function getAllUsers() {
  const res = await apiFetch(`/api/v1/user/all-users`);

  if (!res?.ok) {
    throw new Error("Failed to fetch users");
  }

  const data = await res.json();
  console.log("Parsed users data:", data);
  if (Array.isArray(data)) {
    return data;
  }

  return Array.isArray(data?.users) ? data.users : [];
}
